var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveandAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70512 14.0953H1.98156C1.20161 14.0953 0.569336 13.4631 0.569336 12.6831V2.621C0.569336 1.84105 1.20161 1.20877 1.98156 1.20877H9.04269C9.82264 1.20877 10.4549 1.84105 10.4549 2.621V7.95674",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93066 3.65442H5.86472",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93066 6.40393H8.32913",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85449 9.02695H6.51988",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5279,
    cy: 11.6318,
    r: 2.52708,
    stroke: "white",
    strokeWidth: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 10.3298V13.0011",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1709 11.6311H10.5019H11.8927",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveandAdd);
export default __webpack_public_path__ + "static/media/Save and Add.7a3c88df014830c7fb4b066a01a3c522.svg";
export { ForwardRef as ReactComponent };